export const OfferVariantsItemExt = {
	selectors: {
		variants: document.querySelector(".js-offer-variants-ext"),
		items: Array.prototype.slice.call(
			document.querySelectorAll(".js-offer-variants-ext__item")
		),
		itemHeaders: Array.prototype.slice.call(
			document.querySelectorAll(".js-offer-variants-ext__header")
		),
		itemBoxes: Array.prototype.slice.call(
			document.querySelectorAll(".js-offer-variants-ext__box")
		),
		itemChangeDays: Array.prototype.slice.call(
			document.querySelectorAll(".js-offer-variants-ext__box-change-days")
		),
		itemDays: Array.prototype.slice.call(
			document.querySelectorAll(".js-offer-variants-ext__day-input")
		),
		itemRooms: Array.prototype.slice.call(
			document.querySelectorAll(".js-offer-variants-ext__room-input")
		),
		calendarToggles: Array.prototype.slice.call(
			document.querySelectorAll(".js-offer-variants-ext__calendar-toggle")
		),
		calendarToggleLabels: Array.prototype.slice.call(
			document.querySelectorAll(".js-offer-variants-ext__calendar-toggle--label")
		),
		itemDates: Array.prototype.slice.call(
			document.querySelectorAll(".js-offer-variants-ext__calendar-input")
		),
		itemDatesSurcharge: Array.prototype.slice.call(
			document.querySelectorAll(
				".js-offer-variants-ext__calendar-surcharge-input"
			)
		),
		variantName: document.querySelector('.js-selected-deal--variant-name'),
		variantPrice: document.querySelector('.js-selected-deal--variant-price'),

		// only strings
		item: ".js-offer-variants-ext__item",
		itemBox: ".js-offer-variants-ext__box",
		itemDaysForm: ".js-offer-variants-ext__days-form",
		itemDaysTitleSummary: ".js-offer-variants-ext__box-days-title-summary",
		itemChangeDaysSingle: ".js-offer-variants-ext__box-change-days",
		itemDaysPrice: ".js-offer-variants-ext__days-price",
		itemRoomsForm: ".js-offer-variants-ext__rooms-form",
		itemRoom: ".js-offer-variants-ext__room",
		itemRoomInput: ".js-offer-variants-ext__room-input",
		itemRoomPrice: ".js-offer-variants-ext__room-price",
		itemCalendarWrapper: ".js-offer-variants-ext__calendar-wrapper",
		itemCalendar: ".js-offer-variants-ext__calendar",
		itemCalendarInput: ".js-offer-variants-ext__calendar-input",
		itemCalendarSurchargeInput:
			".js-offer-variants-ext__calendar-surcharge-input",
		itemCalendarMessage: ".js-offer-variants-ext__calendar-message",
		itemCalendarSurchargeMessage:
			".js-offer-variants-ext__calendar-surcharge-message",
		itemRoomsPrice: ".js-offer-variants-ext__rooms-price",
		sendOrderForm: ".js-offer-variants-ext__order-form",
		itemCalendarToggleLabel: ".js-offer-variants-ext__calendar-toggle--label",

	},

	classItem: "c-offer-variants-ext__item",
	classItemActive: "c-offer-variants-ext__item--active",
	classBoxActive: "c-offer-variants-ext__box--open",
	classCalendarWrapperOpen: "c-offer-variants-ext__calendar-wrapper--open",

	init: function () {
		const self = this;

		self.resetItems();
		self.bindItems();
		self.bindInputs();
	},

	// bindings
	bindItems: function () {
		const self = this;

		// bind click
		self.selectors.itemHeaders.forEach(function (header) {
			header.addEventListener("click", function () {
				const item = header.closest(`.${self.classItem}`);
				item.classList.contains(self.classItemActive)
					? self.inactivateItem(item)
					: self.activateItem(item, true);
			});
		});

		// if only one - show it
		if (self.selectors.itemHeaders.length === 1) {
			const header = self.selectors.itemHeaders.shift();
			const item = header.closest(`.${self.classItem}`);
			item.classList.contains(self.classItemActive)
				? self.inactivateItem(item)
				: self.activateItem(item, false);
		}

		// title actions
		self.selectors.itemChangeDays.forEach(function (element) {
			element.addEventListener("click", function (event) {
				event.preventDefault();
				event.stopImmediatePropagation();

				const item = element.closest(`.${self.classItem}`);
				self.activateDaysForm(item);
			});
		});

		// calendar toggle
		self.selectors.calendarToggles.forEach((toggle) => {
			const item = toggle.closest(self.selectors.item);
			const wrapper = item.querySelector(
				self.selectors.itemCalendarWrapper
			);
			toggle.addEventListener("change", function () {

				if (! toggle.checked) {
					wrapper.classList.add(self.classCalendarWrapperOpen);
				} else {
					wrapper.classList.remove(self.classCalendarWrapperOpen);
				}

				item.querySelector(self.selectors.itemCalendarInput).required =
					!toggle.checked;
				item.querySelector(
					self.selectors.itemCalendarSurchargeInput
				).required = !toggle.checked;
			});

			if (toggle.dataset.approach === 'booking-first') {
				toggle.checked = false;
				wrapper.classList.add(self.classCalendarWrapperOpen);
				item.querySelector(self.selectors.itemCalendarInput).required = true;
				item.querySelector(self.selectors.itemCalendarSurchargeInput).required = true;
			}
			if (toggle.dataset.approach === 'booking-mandatory') {
				toggle.checked = true;
				toggle.disabled = true;
				wrapper.classList.add(self.classCalendarWrapperOpen);
				item.querySelector(self.selectors.itemCalendarInput).required = true;
				item.querySelector(self.selectors.itemCalendarSurchargeInput).required = true;
			}
		});
	},

	bindInputs: function () {
		const self = this;

		// all inputs to avoid problems
		self.selectors.itemDays.forEach(function (input) {
			const item = input.closest(self.selectors.item);

			input.addEventListener("change", function () {
				self.updateDaysPrice(item);

				if (input.checked) {
					self.updateOrder(item, "variantId", input.value);
				}
			});

			// If there is only 1 variant, set the default.
			self.updateDaysPrice(item);
			self.updateOrder(item, "variantId", input.value);
		});

		self.selectors.itemRooms.forEach(function (input) {
			const item = input.closest(self.selectors.item);

			input.addEventListener("change", function () {
				self.updateRoomsPrice(item);

				if (input.checked) {
					self.updateOrder(item, "roomId", input.value);
				}
			});
		});

		self.selectors.itemDates.forEach(function (input) {
			const item = input.closest(self.selectors.item);

			input.addEventListener("change", function () {
				self.updateOrder(item, "booking-dates", input.value);
			});
		});

		self.selectors.itemDatesSurcharge.forEach(function (input) {
			const item = input.closest(self.selectors.item);

			input.addEventListener("change", function () {
				const value = JSON.parse(input.value);
				const hasSurcharge = value && value.status;

				const ids = hasSurcharge
					? value.surcharges.map((x) => x.id)
					: "";
				const message = hasSurcharge
					? value.sumMessage
					: null;
				const price = hasSurcharge
					? value.surcharges.reduce((acc, x) => acc + x.value, 0)
					: 0;

				self.updateRoomsPrice(item, price);
				self.updateDatesMessage(item, message);
				self.updateOrder(
					item,
					"booking-dates-surcharge",
					JSON.stringify(ids)
				);
			});
		});
	},

	// items
	activateItem: function (_item, _scroll) {
		const self = this;

		// close active
		const active = document.querySelector(`.${self.classItemActive}`);
		if (active) {
			active.classList.remove(self.classItemActive);
		}

		// scroll to item
		if (_scroll) {
			const position = _item.getBoundingClientRect().top - 40;
			window.scrollTo({
				// note: fix for IE11
				top:
					position +
					(window.scrollY || document.documentElement.scrollTop),
				behavior: "smooth",
			});
		}

		// open item
		_item.classList.add(self.classItemActive);
		self.resetItems();

		// if exists only 1 variant, select it
		const variants = _item.querySelectorAll('input[name="variant"]');
		if (variants.length === 1) {
			self.changeInputCheckedState(variants[0], true);
		}

		// reset date messages
		self.updateDatesMessage(_item, null);
	},

	inactivateItem: function (_item) {
		const self = this;

		_item.classList.remove(self.classItemActive);
		self.resetItems();
	},

	resetItems: function () {
		const self = this;

		self.selectors.items.forEach(function (item) {
			// reset all inputs
			self.selectors.itemDays.forEach(function (input) {
				self.changeInputCheckedState(input, false);
			});

			self.selectors.itemRooms.forEach(function (input) {
				self.changeInputCheckedState(input, false);
			});

			// reset hidden checkboxes from mandatory booking
			self.selectors.calendarToggleLabels.forEach(function (input) {
				input.classList.remove('u-hidden');
			});

			// activate days form
			self.activateDaysForm(item);
			self.updateDaysPrice(item);
		});
	},

	activateForm(_item, _selector) {
		const self = this;

		Array.prototype.slice
			.call(_item.querySelectorAll(self.selectors.itemBox))
			.forEach((box) => box.classList.remove(self.classBoxActive));

		const form = _item.querySelector(_selector);
		if (form) {
			form.classList.add(self.classBoxActive);
		}
	},

	// days
	clickActivateDaysForm: function (_element) {
		const self = this;

		const item = _element.closest(self.selectors.item);
		self.activateDaysForm(item);
	},

	activateDaysForm: function (_item) {
		const self = this;

		// hide summary/change days
		Array.prototype.slice
			.call(_item.querySelectorAll(self.selectors.itemDaysTitleSummary))
			.forEach((element) => element.classList.add("u-hidden"));

		_item
			.querySelector(self.selectors.itemChangeDaysSingle)
			.classList.add("u-hidden");

		// activate form
		self.activateForm(_item, self.selectors.itemDaysForm);
	},

	updateDaysPrice: function (_item) {
		const self = this;

		const selectedInput = _item.querySelector(
			'input[name="variant"]:checked'
		);
		const priceEl = _item.querySelector(self.selectors.itemDaysPrice);
		const price = selectedInput ? selectedInput.dataset.price : null;

		priceEl.innerHTML = price ? `${price} ${priceEl.dataset.currency}` : "";
		priceEl.setAttribute("data-price", price);
	},

	submitDaysForm: function (_element) {
		const self = this;

		const item = _element.closest(self.selectors.item);
		const roomsForm = item.querySelector(self.selectors.itemRoomsForm);

		if (roomsForm) {
			self.activateRoomsForm(item);
		} else {
			self.sendOrder(item);
		}
	},

	// rooms
	activateRoomsForm: function (_item) {
		const self = this;
		const selectedVariant = _item.querySelector(
			'input[name="variant"]:checked'
		);

		self.activateForm(_item, self.selectors.itemRoomsForm);

		// show summary
		const summarySelector = `${self.selectors.itemDaysTitleSummary}[data-variant-id="${selectedVariant.value}"]`;
		// add variant name and price for GA4 datalayer
		self.selectors.variantName.innerHTML = _item.querySelector(summarySelector).dataset.variantname;
		self.selectors.variantPrice.innerHTML = _item.querySelector(summarySelector).dataset.variantprice.replace(/\D/g, '');

		if (_item.querySelector(self.selectors.itemCalendarToggleLabel) !== null) {
			// hide checkbox and show calendar in case of mandatory term selection
			if (selectedVariant.dataset.datemandatory === 'true' && self.selectors.itemCalendarToggleLabel) {
				_item.querySelector(self.selectors.itemCalendarToggleLabel).classList.add('u-hidden');
				_item.querySelector(self.selectors.itemCalendarWrapper).classList.add(self.classCalendarWrapperOpen);
			} else {
				_item.querySelector(self.selectors.itemCalendarToggleLabel).classList.remove('u-hidden');
			}
		}

		_item.querySelector(summarySelector).classList.remove("u-hidden");

		// show change days
		_item
			.querySelector(self.selectors.itemChangeDaysSingle)
			.classList.remove("u-hidden");

		// show allowed rooms
		const rooms = Array.prototype.slice.call(
			_item.querySelectorAll(self.selectors.itemRoom)
		);

		let defaultRoom = null;

		rooms.forEach((room) => {
			const variants = JSON.parse(room.dataset.variants);

			// hide all
			room.classList.add("u-hidden");

			// no variants end here
			if (!variants) return;

			// check if available
			const isAvailable = variants
				.map((x) => `${x}`)
				.includes(selectedVariant.value);

			if (!isAvailable) return;

			// show
			room.classList.remove("u-hidden");

			// set default
			if (!defaultRoom) {
				defaultRoom = room;
			}

			// calculate total prices
			let activeGroupId = document.querySelector(`.${self.classItemActive}`).dataset.groupId;
			let surchargesInputs = room.querySelectorAll('.js-offer-variants-ext__room-surcharge');
			let roomInput = surchargesInputs.filter(function (input) {
				return input.dataset.seasons.includes(activeGroupId);
			})[0];

			const basePrice = roomInput !== undefined ? +roomInput.dataset.basePrice : 0;
			let priceCoef = 1;

			if (roomInput !== undefined && !!+roomInput.dataset.includeNightsPrice)
				priceCoef *= +selectedVariant.dataset.nights;

			if (roomInput !== undefined && !!+roomInput.dataset.includePeoplePrice)
				priceCoef *= +selectedVariant.dataset.people;

			const price = basePrice * priceCoef;

			room.querySelector(self.selectors.itemRoomInput).dataset.price = price;
			room.querySelector(self.selectors.itemRoomPrice).innerHTML = price;
		});

		// select default room
		if (!defaultRoom) {
			return;
		}

		self.changeInputCheckedState(
			defaultRoom.querySelector('input[name="room"]'),
			true
		);
	},

	updateRoomsPrice: function (_item, _dateSurcharge) {
		const self = this;

		const daysPrice = +_item.querySelector(self.selectors.itemDaysPrice)
			.dataset.price; // this will always be set

		const selectedInput = _item.querySelector('input[name="room"]:checked');
		let roomPrice = 0;
		if (selectedInput) {
			const noEffect = selectedInput.dataset.noEffect ? selectedInput.dataset.noEffect : '0';
			roomPrice = noEffect === '0' ? +selectedInput.dataset.price : 0;
		}

		const dateSurcharge = _dateSurcharge || 0;

		const price = daysPrice + roomPrice + dateSurcharge;

		const priceEl = _item.querySelector(self.selectors.itemRoomsPrice);
		priceEl.innerHTML = price;
	},

	updateDatesMessage: function (_item, _message) {
		const self = this;

		const calendarMessage = _item.querySelector(
			self.selectors.itemCalendarMessage
		);
		const calendarSurchargeMessage = _item.querySelector(
			self.selectors.itemCalendarSurchargeMessage
		);

		if (!calendarMessage || !calendarSurchargeMessage) {
			return;
		}

		if (_message && _message.trim() !== '') {
			// hide default mmessage
			calendarMessage.classList.add("u-hidden");

			// show surcharge message
			calendarSurchargeMessage.classList.remove("u-hidden");
			calendarSurchargeMessage.querySelector(
				".c-info-box__content"
			).innerHTML = _message;
		} else {
			// show default message or hide it if there's only 1 room
			const roomsCount = Array.prototype.slice
				.call(_item.querySelectorAll(self.selectors.itemRoom))
				.filter((x) => !x.classList.contains("u-hidden")).length;

			if (roomsCount > 1) {
				calendarMessage.classList.remove("u-hidden");
				calendarSurchargeMessage.querySelector(
					".c-info-box__content"
				).innerHTML = "";
			} else {
				// calendarMessage.classList.add("u-hidden");
			}

			// hide surcharge message
			calendarSurchargeMessage.classList.add("u-hidden");
		}
	},

	submitRoomsForm: function (_element) {
		const self = this;

		const item = _element.closest(self.selectors.item);
		self.sendOrder(item);
	},

	// whole reservation
	updateOrder: function (_item, _name, _value) {
		const self = this;

		const input = _item
			.querySelector(self.selectors.sendOrderForm)
			.querySelector(`input[name="${_name}"]`);

		input.value = _value;
	},

	sendOrder: function (_item) {
		const self = this;
		_item.querySelector(self.selectors.sendOrderForm).submit();
	},

	changeInputCheckedState: function (_input, checked) {
		if (!_input) {
			return;
		}

		_input.checked = checked;
		_input.dispatchEvent(new CustomEvent("change"));
	},
};

OfferVariantsItemExt.init();
window.OfferVariantsItemExt = OfferVariantsItemExt;
